export const playDing = () => {
  const AudioContext = window.AudioContext
  if (!AudioContext) return

  const ctx = new AudioContext()
  const now = ctx.currentTime
  // (C6, E6, G6, C7)
  const notes = [1046.5, 1318.51, 1567.98, 2093.0]

  notes.forEach((freq, index) => {
    const osc = ctx.createOscillator()
    const startTime = now + index * 0.5
    const duration = 0.5
    const gainNode = ctx.createGain()

    osc.type = 'sine'
    osc.frequency.setValueAtTime(freq, now)
    osc.connect(gainNode)

    gainNode.connect(ctx.destination)
    gainNode.gain.setValueAtTime(0, startTime)
    gainNode.gain.linearRampToValueAtTime(0.2, startTime + 0.05)
    gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration)

    osc.start(startTime)
    osc.stop(startTime + duration)
  })
}
